import { AxiosAdapter } from './http/axios.adapter';

export const fintraceApiFetcher = new AxiosAdapter({
  baseURL: import.meta.env.VITE_FINTRACE_API_URL as string,
});
